
import React, { useState, useEffect } from "react";
import { Container, Grid, Box, TextField, Button, Autocomplete } from "@mui/material";
import Title from "../../../Title";
import Notify from "../../../Notify";
import { getData, postData, putData } from "../../../../services/library";
import { logEventos } from "../../../../services/services";
import FormPreciosEspeciales from "./FormPreciosEspeciales";
import FormActualizar from "./FormActualizar";

function AddPrecioEspecial(props) {
  const [datoslista, setDatoslista] = useState({
    id_cliente: null,
    lt_con_iva: "",
    lt_sin_iva: "",
    kg_con_iva: "",
    kg_sin_iva: "",
    vigencia: "",
    fin_vigencia: null
  });

  const [disabledGuardar, setDisabledGuardar] = useState(false);
  const [clientes, setClientes] = useState();
  const [clienteSeleccionada, setClienteSeleccionada] = useState("");
  const [datosDirec, setDatosDirec] = useState([]);
  const [cambieCli, setCambieCli] = useState(false);
  const [cambieDirec, setcambieDirec] = useState(false);
  const [aumento, setAumento] = useState(null);
  const [porcentaje, setPorcentaje] = useState(null);

  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });

  useEffect(() => {
    getData('/precios_especiales/clientes', setClientes)
  }, [])

  const obtenerLista = () =>{
     getData(`/precios_especiales/xcliente/${clienteSeleccionada.id_cliente}`, setDatosDirec)
  }

  // //una vez que está seleccionada la diereccion de entrega verificaos que no haya un precio vigente cargado por dios que sueño que tengo :'()
  useEffect(() => {
   obtenerLista()      
  }, [cambieCli]);

  console.log("cambie Cli", cambieCli)
  console.log("clienteSeleccionada",clienteSeleccionada);
  
  

  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
  };

  const size = "small";

  const handleClose = () => {
    props.alta(false);
    props.tabla(true);
  };

  //funcion para guardar 
  const guardarPrecio = async (e) => {
    setDisabledGuardar(false);
    postData(e, '/precios_especiales',
      {
        id_cliente: clienteSeleccionada.id_cliente,
        lt_con_iva: datoslista.lt_con_iva.replace(',', '.'),
        lt_sin_iva: datoslista.lt_sin_iva.replace(',', '.'),
        kg_con_iva: datoslista.kg_con_iva.replace(',', '.'),
        kg_sin_iva: datoslista.kg_sin_iva.replace(',', '.'),
        vigencia: datoslista.vigencia,
        usuario: localStorage.getItem("user"),
        fin_vigencia: datoslista.fin_vigencia
      },
      setNotificacion
    )
    logEventos("Guardar nuevo precio especial", "Precio especiales", "referencias tabla", localStorage.getItem('user'));
  };

  //FUNCION PARA HACER UPDATE EN CASO DE QUE EXISTA UNA LISTA DE PRECIOS JAJAJAJJAAJAJJAJA
  const updateLista = async (e) => {
    e.preventDefault();
    postData(e, '/precios_especiales',
      {
        id_cliente: clienteSeleccionada.id_cliente,
        lt_con_iva: datoslista.lt_con_iva,
        lt_sin_iva: datoslista.lt_sin_iva,
        kg_con_iva: datoslista.kg_con_iva,
        kg_sin_iva: datoslista.kg_sin_iva,
        vigencia: datoslista.vigencia,
        usuario: localStorage.getItem("user"),
        fin_vigencia: datoslista.fin_vigencia,
        aumento_en_pesos:  aumento,
        aumento_en_porcentaje:porcentaje
      },
      setNotificacion,
    );
    const nuevaVigencia = datoslista.vigencia;
    const fechaFinAnterior = new Date(nuevaVigencia);
    fechaFinAnterior.setDate(fechaFinAnterior.getDate() - 1); // Un día antes

  // Convertir a formato ISO yyyy-mm-dd
  const fechaFinAnteriorStr = fechaFinAnterior.toISOString().split('T')[0];
    putData(e,
      `/precios_especiales/${datosDirec[0].id_precioespecial}`,
      {
        fin_vigencia:fechaFinAnteriorStr,
        usuario: localStorage.getItem('user')
      },
      setNotificacion,
    )
    logEventos("Agregar fecha vigencia precio especial", "Precio especiales", "referencias tabla", localStorage.getItem('user'));
  };

  const almacenar = (event) => {
    const { name, value } = event.target;

    // Guardamos el valor directamente para que se vea lo que escribe el usuario (aunque no sea número aún)
    let newValue = { ...datoslista, [name]: value };

    if (value === "") {
            setDatoslista({
            ...datoslista,
            lt_sin_iva: "",
            lt_con_iva: "",
            kg_sin_iva: "",
            kg_con_iva: "",
            [name]: "",
            });
            return;
    }

    // Si llegó hasta acá, significa que el valor es válido para cálculos
    const valorNormalizado = value.replace(',', '.');
    const floatValue = parseFloat(valorNormalizado);

    if (isNaN(floatValue)) {
      setDatoslista(newValue); // Si aún no se puede parsear, no hacemos cálculos
      return;
    }

    const densidad =
      clienteSeleccionada && clienteSeleccionada.id_empresa === 1
        ? clienteSeleccionada.densidad_hipergas
        : clienteSeleccionada.densidad_autogas;

    const truncar = (num) =>
            Number(num).toFixed(2).replace('.', ',');

    // Lógica de cálculos
    if (name === "lt_sin_iva") {
      const precioConIva = floatValue * clienteSeleccionada.porcentaje_iva;
      const kgConIva = precioConIva / densidad;
      const kgSinIva = kgConIva / clienteSeleccionada.porcentaje_iva;
      
      newValue.lt_con_iva = truncar(precioConIva);
      newValue.kg_con_iva = truncar(kgConIva);
      newValue.kg_sin_iva = truncar(kgSinIva);
    }

    if (name === "kg_sin_iva") {
      const precioConIva = floatValue * clienteSeleccionada.porcentaje_iva;
      const ltConIva = precioConIva * densidad;
      const ltSinIva = ltConIva / clienteSeleccionada.porcentaje_iva;

      newValue.lt_sin_iva = truncar(ltSinIva);
      newValue.kg_con_iva = truncar(precioConIva);
      newValue.lt_con_iva = truncar(ltConIva);
    }

    if (name === "kg_con_iva") {
      const precioSinIva = floatValue / clienteSeleccionada.porcentaje_iva;
      const ltConIva = precioSinIva / densidad;
      const ltSinIva = ltConIva / clienteSeleccionada.porcentaje_iva;
      
      newValue.lt_sin_iva = truncar(ltSinIva);
      newValue.kg_sin_iva = truncar(precioSinIva);
      newValue.lt_con_iva = truncar(ltConIva);

    }

    if (name === "lt_con_iva") {
      const precioSinIva = floatValue / clienteSeleccionada.porcentaje_iva;
      const kgSinIva = precioSinIva * densidad;
      const kgConIva = kgSinIva * clienteSeleccionada.porcentaje_iva;
      newValue.kg_con_iva = truncar(kgConIva);
      newValue.lt_sin_iva = truncar(precioSinIva);
      newValue.kg_sin_iva = truncar(kgSinIva);
    }
    setDatoslista(newValue);
  };

  useEffect(() => {
  if (
    datoslista.lt_con_iva &&
    datoslista.lt_sin_iva &&
    datoslista.kg_con_iva &&
    datoslista.kg_sin_iva &&
    datoslista.vigencia
  ) {
    setDisabledGuardar(false);  // Todos los campos tienen valor: habilito
  } else {
    setDisabledGuardar(true);   // Algún campo está vacío: deshabilito
  }
  }, [datoslista.lt_con_iva, datoslista.lt_sin_iva, datoslista.kg_con_iva, datoslista.kg_sin_iva, datoslista.vigencia]);

  useEffect(() => {
    if ( cambieCli === true) {
      setDatoslista((prevDatos) => ({
        ...prevDatos,
        lt_sin_iva: "",
        lt_con_iva: "",
        kg_sin_iva: "",
        kg_con_iva: ""
      }));
      // setcambieDirec(false)
      setCambieCli(false);
    }
  }, [cambieCli, ])


  //ENTONCES EL FORMULARIO SE VA A DIVIDIR EN LO SIGUIENTE: 
  //PRIMERO SE HABILITA PARA QUE SE CARGUE UN NUEVO PRECIO, SI YA EXISTE UNO
  //LE VA A PEGIMTAR AL USUARIO SI NECESITA O SI DESEA CARGAR UNO DEPENDIENDO LO QIE SE QIERA
  //ESTO VA A PASAR CARA VEZ QUE EL USUARIO ELIJA UNA DIRECCION DE ENTREGA
  return (
    <div>
      <Container>
        <Title
          titulo={datosDirec && datosDirec.length === 0 ? "Nuevo Precio" : "Actualizar precio"}
          handleClose={handleClose} />
        <form onSubmit={guardarPrecio} autoComplete="off">
          <Box
            backgroundColor="#F4F6F6"
            mt={2}
            p={3}
            mb={5}
            border={0.5}
            borderColor={"#ABB2B9"}
            borderRadius={4}
          >
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              spacing={2}
            >
              <Grid item xs={8}>
                {clientes && (
                  <Autocomplete
                    disabled={!clientes}
                    size={size}
                    focused
                    disableClearable
                    id="clientes"
                    noOptionsText={"Cliente INEXISTENTE"}
                    options={clientes}
                    autoHighlight
                    getOptionLabel={(clientes) => `${clientes.razon_social.trim("")} (${clientes.nombre_producto})`}
                    onChange={(event, value) => {
                      setClienteSeleccionada(value)
                      setCambieCli(true)
                    }}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        key={option.id}
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {`${option.razon_social.trim("")} (${option.nombre_producto})`}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        style={style}
                        required
                        focused
                        size="small"
                        placeholder="Tipee para buscar..."
                        {...params}
                        label="Clientes"
                        inputProps={{
                          ...params.inputProps,
                        }}
                      />
                    )}
                  />
                )}
              </Grid>
             
              {datosDirec && datosDirec.length === 0 ?
                <FormPreciosEspeciales
                  size={size}
                  style={style}
                  almacenar={almacenar}
                  datoslista={datoslista} />
                :
                <FormActualizar
                  datosExisten={datosDirec}
                  datoslista={datoslista}
                  size={size}
                  style={style}
                  setDatoslista={setDatoslista}
                  disabledGuardar={disabledGuardar}
                  setDisabledGuardar={setDisabledGuardar}
                  aumento={aumento}
                  setAumento={setAumento}
                  porcentaje={porcentaje}
                  setPorcentaje={setPorcentaje}
                  almacenar={almacenar} />
              }

            </Grid>
            <Grid
              container
              justifyContent="space-between"
              alignItems="flex-end"
              mt={2}
            >
              <Button variant="contained" onClick={handleClose} color="error">
                Volver
              </Button>

              <Button
                variant="contained"
                type="submit"
                color="success"
                onClick={datosDirec && datosDirec.length > 0 ? updateLista : guardarPrecio}
                disabled={disabledGuardar}
              >
                {datosDirec && datosDirec.length > 0 ? "Actualizar" : "Guardar Precio"}
              </Button>
            </Grid>
          </Box>
        </form>
        {notificacion && notificacion.open ? (
          <Notify
            mensaje={notificacion.mensaje}
            open={notificacion.open}
            color={notificacion.color}
            handleClose={handleClose}
            severity={notificacion.severity}
          />
        ) : null}
      </Container>
    </div>
  )
}

export default AddPrecioEspecial
//----- Component --------------------------------------------------------/
// Developer :  Daiana Curcio / Nicolas pascucci
// Creation Date :26/06/2024
// Version : 1
// Description : Agregar precios
//------Changes ----------------------------------------------------------//
// Change Date : 15/8
// Change by : Candela Grosso
// Change description: Acomode el titulo y saque los console.log - Separe en dos componetntes los fomularios de alta y de actualizacion para que se carguen directamente...
//========================================================================/

  